import React, { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteAddress } from "../../../Redux/Customers/Address/Action";
import { getAllAddress } from "../../../Redux/Customers/Address/Action";

const AddressCard = ({ addressItem, deleteRequired, showToast }) => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");

  const handleDeleteAddress = async (id) => {
    await dispatch(deleteAddress({ id, jwt }));
    await dispatch(getAllAddress(jwt));
    showToast();
  };

  return (
    <div>
      {/* <h1 className="text-lg font-semibold py-4">Delivery Adress</h1> */}
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <p className="font-semibold">{`${addressItem?.firstName} ${addressItem?.lastName}`}</p>
          {deleteRequired && (
            <DeleteIcon
              className="cursor-pointer"
              onClick={() => handleDeleteAddress(addressItem._id)}
            />
          )}
        </div>

        <p>
          {`${addressItem?.streetAddress} ${addressItem?.city} ${addressItem?.state} ${addressItem?.zipCode}`}
        </p>
        <div className="space-y-1">
          <p className="font-semibold">Phone Number</p>
          <p>{addressItem?.mobile}</p>
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
